import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  Button,
  DialogActions,
} from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import { Tags } from 'components/FormInputs';

const TagsDialog = ({
  isTagOpen,
  setIsTagOpen,
  data,
  changeTags,
  tags,
}) => {
  const intl = useIntl();
  return (
    <Dialog
      fullWidth
      open={isTagOpen}
      onClose={() => setIsTagOpen(false)}
      style={{ overflowY: 'visible' }}
    >
      <DialogContent style={{ minHeight: '300px', overflow: 'visible' }}>
        <Tags
          name="tags"
          errors={{}}
          label={(
            <FormattedMessage
              id="Add tags"
              defaultMessage="Add tags"
            />
          )}
          placeholder={intl.formatMessage({ id: 'Add tags', defaultMessage: 'Select' })}
          value={data.tags && data.tags.map(({ id, tag }) => ({ value: id, label: tag }))}
          options={tags.map(({ id, tag }) => ({ value: id, label: tag }))}
          onChange={(selected) => {
            changeTags(selected);
          }}
          creatable
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setIsTagOpen(false)}
          color="primary"
        >
          <FormattedMessage
            id="Ok"
            defaultMessage="Ok"
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TagsDialog.propTypes = {
  isTagOpen: PropTypes.bool,
  setIsTagOpen: PropTypes.func,
  data: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  changeTags: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.shape({})),
};

export default TagsDialog;
